@if (sessao; as usuario) {
  <!--
    O gatilho é o BLOCO DE PERFIL do rodapé do menu lateral, não um nome solto
    na barra superior. Revisão do dono em 01/09/2026: o nome aparecia nos dois
    lugares, e o do menu lateral — que parecia clicável — era decoração inerte.
    É um ou o outro; as duas referências põem no menu lateral, com avatar, nome,
    e-mail e um controle à direita indicando que abre.
  -->
  <button
    type="button"
    class="mg-perfil"
    [matMenuTriggerFor]="menuDoUsuario"
    aria-haspopup="menu">
    <mg-avatar [nome]="usuario.name ?? ''" />
    <span class="mg-perfil__texto">
      <span class="mg-perfil__nome">{{ usuario.name }}</span>
      <span class="mg-perfil__email">{{ usuario.email }}</span>
    </span>
    <mat-icon class="mg-perfil__seta" svgIcon="unfold_more" aria-hidden="true" />
  </button>
  <mat-menu #menuDoUsuario="matMenu" xPosition="after" yPosition="above">
    <button type="button" mat-menu-item (click)="perfil()">Meu perfil</button>
    @if (ehTenant) {
      <button type="button" mat-menu-item (click)="minhaAssinatura()">Minha assinatura</button>
      @if (assistenteIncluido) {
        <button type="button" mat-menu-item (click)="mcp()">Conector MCP</button>
      }
    }
    <button type="button" mat-menu-item (click)="sair()">Sair</button>
  </mat-menu>
}
